const atualizarMecanicos = (state, mecanicos) => {
    state.mecanicos = mecanicos;
}

const atualizarMecanico = (state, mecanico) => {
    state.mecanico = mecanico;
}

const updateMecanico = (state, mecanico) => {
    const item = state.mecanicos.find(item => item.id === mecanico.id);

    Object.assign(item, mecanico);
}

export default {
    atualizarMecanicos,
    atualizarMecanico,
    updateMecanico
}
